import React, {Component} from 'react';
import {Icon} from "@blueprintjs/core";
import {Map} from "immutable";

class AlertRowDetail extends Component {

    render() {
        // Send Schedule field
        const sendSchedule = this.props.alertType.get('send_schedule') || Map({});
        let sendScheduleString = '';
        switch (sendSchedule.get('interval')) {
            case 'day':
                sendScheduleString = 'Diariamente, ' + sendSchedule.get('hour');
                break;
            case 'week':
                let day = 'Lunes';
                switch (sendSchedule.get('day')) {
                    case 1:
                        day = 'Lunes';
                        break;
                    case 2:
                        day = 'Martes';
                        break;
                    case 3:
                        day = 'Miercoles';
                        break;
                    case 4:
                        day = 'Jueves';
                        break;
                    case 5:
                        day = 'Viernes';
                        break;
                    case 6:
                        day = 'Sabado';
                        break;
                    case 7:
                        day = 'Domingo';
                        break;
                    default:
                        break;
                }
                sendScheduleString = 'Semanalmente, ' + day + ', ' + sendSchedule.get('hour');
                break;
            default:
                sendScheduleString = '--';
                break;
        }

        return (
            <div className="row" style={{ marginBottom: 30 }}>
                <div className="col-auto">
                    <label>¿Alerta activa?</label>
                    <div className="text-center">
                        { this.props.alertType.get('status') === 'active' ? <Icon icon="tick"/> : <Icon icon="cross"/> }
                    </div>
                </div>
                <div className="col-auto">
                    <label>¿Enviar resumen por correo?</label>
                    <div className="text-center">
                        { this.props.alertType.get('send_summary_email') ? <Icon icon="tick"/> : <Icon icon="cross"/> }
                    </div>
                </div>
                <div className="col-3">
                    <label>Periodicidad de envío</label>
                    <div>
                        <span style={{fontSize: '0.9rem', fontWeight: 'bold'}}>
                            { sendScheduleString }
                        </span>
                    </div>
                </div>
                <div className="col">
                    <label>Destinatarios</label>
                    <div>
                        <span style={{fontSize: '0.9rem', fontWeight: 'bold'}}>
                            { (this.props.alertType.get('email_list') && this.props.alertType.get('email_list').join(', ')) || '--' }
                        </span>
                    </div>
                </div>
                <div className="col-auto">
                    <label></label>
                    <div className="text-center">
                        <Icon
                            className="cursor-pointer"
                            icon="edit"
                            onClick={() => this.props.openModal(
                                'editAlertDialog',
                                this.props.alertType
                            )}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default AlertRowDetail;



// WEBPACK FOOTER //
// ./src/components/common/AlertRowDetail.js